import type { Address } from "../../../../types";

const DEFAULT_COUNTRY_CODE = "US";

export const addressToAddressSearch = (address?: Address) => {
    return [address?.Address1, address?.City, address?.StateProvinceCode, address?.PostalCode, address?.CountryCode]
        .filter(Boolean)
        .join(", ");
};

export const addressSearchToAddress = (value: string) => {
    const [address1 = "", city = "", state = "", zip = "", countryCode = DEFAULT_COUNTRY_CODE] = value.split(", ");
    const countryCodeUpperCase = countryCode.toUpperCase();
    return { address1, city, state, zip, countryCode: countryCodeUpperCase };
};
